(function handleChunkLoadError() {
  // 防止无限刷新（只允许自动刷新一次）
  const RELOAD_FLAG = 'chunk_reloaded'
  const hasReloaded = sessionStorage.getItem(RELOAD_FLAG)

  // 捕获同步错误
  window.addEventListener('error', (e) => {
    const msg = e.message || ''
    if (
      (msg.includes('ChunkLoadError') || msg.includes('Loading chunk')) &&
      !hasReloaded
    ) {
      sessionStorage.setItem(RELOAD_FLAG, '1')
      window.location.reload() // 自动刷新恢复
    }
  }, true)

  // 捕获异步/Promise 错误（Vue 懒加载 90% 走这里）
  window.addEventListener('unhandledrejection', (e) => {
    const err = e.reason || {}
    if (
      (err.name === 'ChunkLoadError' || (err.message || '').includes('Loading chunk')) &&
      !hasReloaded
    ) {
      sessionStorage.setItem(RELOAD_FLAG, '1')
      window.location.reload()
    }
  })
})()


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang' // 加入

// Element UI 后台
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })

Vue.use(i18n)

import './assets/css/index.scss'


// UniIcons 兼容组件（支持 uni-app 语法迁移到 Vue）
import UniIcons from '@/components/UniIcons.vue'
Vue.component('uni-icons', UniIcons)

// Vant 移动端
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

// axios
import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'

Vue.config.productionTip = false



// 全局错误处理（兜底，防止红屏）
Vue.config.errorHandler = function (err) {
  if (err.name === 'ChunkLoadError' || (err.message || '').includes('Loading chunk')) {
    return // 静默处理，不报错
  }
  // 其他错误可以上报
  console.error('全局错误：', err)
}


new Vue({
  router,
  store,
  i18n, // 加入
  render: h => h(App)
}).$mount('#app')